
// import Vue from 'vue';
// import VueRouter from 'vue-router';
import {store} from './store/store';
import router from './routes';



router.beforeEach((to, from , next) => {
  //console.log(to.fullPath)

  // if(to.name && to.name=='login'){
  //   document.body.className = 'gray-bg';
  // }else{
  //   document.body.className = 'pace-done pace-done';
  // }

  let token = null;
  let tokenPainel = null;
  if(store.getters['app/isAuth']){
    token = store.getters['app/getToken'];
  }else if(store.getters['app/tokenPainel']){
    tokenPainel = store.getters['app/tokenPainel'];
  }else{
    store.dispatch('app/tryAutoLogin');
    if(store.getters['app/isAuth']){
      token = store.getters['app/getToken'];
    }
  }


  let isAuth = false;
  if(to.matched && to.matched.length>0){
    if(to.matched[0].name == 'auth'){
      isAuth = true;
    }
  }

  if( token!= null ){
    //if(to.name==='login'){
    if(isAuth){
      next('/');
    }else{
      next();
    }
    
  }else if (tokenPainel!=null || (to.query.tokenpainel && to.query.tokenpainel!='')) {    
    if(to.name==='painel'){      
      next();
    }else{
      next('/login');
    }
  }else{
    // console.log('to',to);
    //if(to.name==='login'){
    if(isAuth){
      next();
    }else{
      next('/login');
    }
  }
});




export default router;
